export default "__VITE_ASSET__S8QmK3DN__"